// 静态展示数据：cg51 栏目导航 · 首页
// 本文件仅承载展示内容，不接接口、不存库

export interface NavItem {
  label: string;
  href: string;
}

export const navItems: NavItem[] = [
  { label: "栏目导航", href: "#zones" },
  { label: "热点专楼", href: "#hot" },
  { label: "吃瓜合集", href: "#gossip" },
  { label: "分区盘点", href: "#zones" },
  { label: "话题大全", href: "#topics" },
  { label: "常见问题", href: "#faq" },
];

export interface HotThread {
  id: string;
  zone: string;
  badge: string;
  title: string;
  digest: string;
  replies: number;
  updated: string;
  img: string;
}

export const hotThreads: HotThread[] = [
  {
    id: "hot-1",
    zone: "内娱区",
    badge: "置顶热楼",
    title: "顶流巡回演唱会连开三场，全平台观演实录刷屏",
    digest: "抢票曲线、舞台直拍与后劲长评同场激辩，从现场应援到散场热议，一栋楼聊到天亮。",
    replies: 1287,
    updated: "12 分钟前更新",
    img: "https://readdy.ai/api/search-image?query=stylized%20editorial%20collage%20of%20a%20concert%20stage%20with%20confetti%20and%20warm%20stage%20lights%2C%20gossip%20magazine%20cover%20aesthetic%2C%20warm%20coral%20and%20amber%20tones%2C%20paper%20texture%2C%20newsprint%20graphic%20elements%2C%20artistic%20and%20abstract%20not%20photorealistic&width=720&height=460&seq=hot-1-2026&orientation=landscape",
  },
  {
    id: "hot-2",
    zone: "影视区",
    badge: "热评大战",
    title: "暑期档爆款剧大结局落幕，开放式收尾吵翻评论区",
    digest: "导演访谈、删减片段与二创解读轮番登场，好人与坏人到最后都没说清谁对谁错。",
    replies: 964,
    updated: "36 分钟前更新",
    img: "https://readdy.ai/api/search-image?query=stylized%20cinematic%20collage%20of%20film%20clapperboard%20and%20film%20reel%20with%20warm%20golden%20light%2C%20gossip%20magazine%20spread%20aesthetic%2C%20coral%20and%20amber%20editorial%20tones%2C%20paper%20grain%20texture%2C%20abstract%20artistic%20composition%20not%20a%20real%20photograph&width=720&height=460&seq=hot-2-2026&orientation=landscape",
  },
  {
    id: "hot-3",
    zone: "音乐区",
    badge: "票价争议",
    title: "音乐节阵容官宣，分区定价与黄牛问题再上热搜",
    digest: "乐迷晒出分区票价对比，主办方口径前后不一，讨论从现场体验一路延展到行业生态。",
    replies: 731,
    updated: "1 小时前更新",
    img: "https://readdy.ai/api/search-image?query=stylized%20music%20festival%20outdoor%20stage%20at%20dusk%20with%20warm%20stage%20lights%20and%20silhouettes%2C%20gossip%20magazine%20editorial%20style%2C%20warm%20coral%20and%20amber%20palette%2C%20grainy%20paper%20texture%2C%20artistic%20abstract%20illustration%20not%20a%20real%20photo&width=720&height=460&seq=hot-3-2026&orientation=landscape",
  },
  {
    id: "hot-4",
    zone: "电竞区",
    badge: "爆冷夜",
    title: "世界赛小组赛爆出冷门，老将离场传闻开始发酵",
    digest: "阵容复盘、关键一波失误与赛后采访逐条拆解，谁去谁留的悬念成了全楼最热话题。",
    replies: 612,
    updated: "2 小时前更新",
    img: "https://readdy.ai/api/search-image?query=stylized%20esports%20arena%20with%20glowing%20screens%20and%20confetti%2C%20warm%20amber%20and%20coral%20neon%20glow%2C%20gossip%20magazine%20editorial%20collage%2C%20paper%20texture%20overlay%2C%20abstract%20artistic%20style%20not%20photorealistic&width=720&height=460&seq=hot-4-2026&orientation=landscape",
  },
];

export interface GossipCollection {
  id: string;
  zone: string;
  theme: string;
  count: number;
  updated: string;
  note: string;
}

export const gossipCollections: GossipCollection[] = [
  { id: "go-1", zone: "影视区", theme: "剧组秘辛合集", count: 32, updated: "今日更新", note: "幕后细节与同组关系时间线" },
  { id: "go-2", zone: "综艺区", theme: "综艺名场面复盘", count: 48, updated: "昨日更新", note: "高能片段一帧帧重放解读" },
  { id: "go-3", zone: "音乐区", theme: "演唱会高光存档", count: 21, updated: "2 天前更新", note: "歌单、返场与散场名场面" },
  { id: "go-4", zone: "体育区", theme: "转会内幕时间线", count: 15, updated: "本周更新", note: "从传闻到官宣的完整脉络" },
  { id: "go-5", zone: "时尚圈", theme: "红毯造型红黑榜", count: 27, updated: "昨日更新", note: "高光造型与翻车现场并排看" },
  { id: "go-6", zone: "海外区", theme: "圈内关系图谱", count: 40, updated: "本周更新", note: "韩娱泰娱日娱的热点联动" },
];

export interface ZoneItem {
  id: string;
  name: string;
  en: string;
  digest: string;
  threads: number;
  icon: string;
}

export const zones: ZoneItem[] = [
  { id: "z-in", name: "内娱区", en: "INNER STAR", digest: "新剧上线、舞台名场面与资源瓜一网打尽", threads: 3560, icon: "ri-star-line" },
  { id: "z-movie", name: "影视区", en: "FILM & TV", digest: "票房盘点、剧集吐槽与演员话题的集中地", threads: 4820, icon: "ri-film-line" },
  { id: "z-music", name: "音乐区", en: "MUSIC", digest: "新歌榜单、音乐节现场与乐评大战", threads: 2740, icon: "ri-music-2-line" },
  { id: "z-sport", name: "体育区", en: "SPORTS", digest: "赛事名场面、转会与赛后热评随时更新", threads: 3180, icon: "ri-trophy-line" },
  { id: "z-esport", name: "电竞区", en: "ESPORTS", digest: "转会瓜与大小赛复盘的一场不落", threads: 2240, icon: "ri-gamepad-line" },
  { id: "z-abroad", name: "海外区", en: "OVERSEAS", digest: "韩娱、泰娱与日娱话题的联动专区", threads: 1950, icon: "ri-global-line" },
  { id: "z-tech", name: "科技圈", en: "TECH", digest: "数码新品与行业圈内的软性八卦", threads: 1420, icon: "ri-cpu-line" },
  { id: "z-biz", name: "财经圈", en: "BUSINESS", digest: "商战内幕与职场话题的轻盘点", threads: 980, icon: "ri-line-chart-line" },
];

export interface TopicRank {
  rank: number;
  title: string;
  zone: string;
  heat: number;
  trend: "up" | "down" | "flat";
}

export const topicRanks: TopicRank[] = [
  { rank: 1, title: "爆款剧大结局开放收尾争议", zone: "影视区", heat: 92, trend: "up" },
  { rank: 2, title: "顶流巡回演唱会观演实录", zone: "内娱区", heat: 88, trend: "up" },
  { rank: 3, title: "音乐节分区定价与黄牛问题", zone: "音乐区", heat: 75, trend: "flat" },
  { rank: 4, title: "老将世界赛离场传闻发酵", zone: "电竞区", heat: 63, trend: "up" },
  { rank: 5, title: "红毯造型红黑榜更新", zone: "时尚圈", heat: 58, trend: "down" },
  { rank: 6, title: "暑期档新片首周口碑复盘", zone: "影视区", heat: 47, trend: "up" },
  { rank: 7, title: "综艺改版后口碑两极分化", zone: "综艺区", heat: 39, trend: "flat" },
  { rank: 8, title: "新专先行曲空降热搜", zone: "音乐区", heat: 31, trend: "up" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  { q: "cg51 是一个什么样的栏目导航？", a: "cg51 把分散在各大平台的热点专楼、吃瓜合集与分区盘点收拢到一页，按兴趣分区整理成清晰的话题大全。你不用在多个 App 之间来回翻找，进 cg51 就能顺着分区直达内容。" },
  { q: "热点专楼和普通帖子有什么不同？", a: "热点专楼会把同一个事件下的观演实录、赛后复盘、后续进展与网友高赞评论汇总在同一栋楼里按时间排序，方便你一次看完前因后果，不必自己拼线索。" },
  { q: "吃瓜合集多久更新一次？", a: "各分区会按事件热度滚动更新，热点当天的合集基本每几分钟就会刷新置顶状态。更新时间都标注在卡片上，你可以按需挑选最新的合集浏览。" },
  { q: "话题大全里的热度是怎么算的？", a: "热度综合了回复条数、更新时间与讨论增速三个维度，反映一个话题此刻被讨论的集中程度，代表的是「现在最值得点开什么」而不是简单堆楼数。" },
  { q: "我该从哪里开始逛 cg51？", a: "先从分区盘点里挑一个你最感兴趣的区点进去，再回到顶部看热点专楼，最后用话题大全扫一眼全站此刻最热的内容即可。三条路都能通到内容。" },
];